import { createGdevelopTheme } from '../CreateTheme';

import styles from './albaikThemeVariables.json';
import './albaikThemeVariables.css';
export default createGdevelopTheme({
  styles,

  rootClassNameIdentifier: 'albaikTheme',
  paletteType: 'dark',
});

// export default createGdevelopTheme(styles, 'albaikTheme', 'dark');
